// @ts-nocheck
import { init as initApm } from '@elastic/apm-rum';
import packageJson from '../../package.json';

const apm = initApm({
  // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
  serviceName: `${packageJson.name}-${window.location.host.replace(/[.:]/g, '-')}`,

  // Set custom APM Server URL (default: http://localhost:8200)
  // @ts-ignore
  serverUrl: `${window.CONFIG.ERROR_LOGGER}`,

  // Set service version (required for sourcemap feature)
  serviceVersion: packageJson.version,
  environment: window.location.host.replace(/[.:]/g, '-'),
  active: process.env.NODE_ENV === 'production',
  // @ts-ignore
  distributedTracingOrigins: window.location.pathname,
  logLevel: 'warn',
});

export default apm;
